const { m } = require('minthril');
const routemeup = require('routemeup').default;
const { Home } = require('./home');
const { ProductsPage } = require('./products');
const { ProductPage } = require('./product');
const { AboutPage } = require('./about');
const { CartPage } = require('./cart');
const { ContactPage } = require('./contact');
const { NotFoundPage } = require('./notFound');
const { PrivacyPolicyPage } = require('./privacyPolicy');
const { PrivacyChoicesPage } = require('./privacyChoices');
const { CollectionsPage, CollectionPage } = require('./collections');

function Pages() {
  return {
    view: ({ attrs }) => {
      const route = routemeup({
        '/': () => 'home',
        '/products': () => 'products',
        '/about': () => 'about',
        '/cart': () => 'cart',
        '/contact': () => 'contact',
        '/policies/privacy-policy': () => 'privacy-policy',
        '/pages/about-us': () => 'about',
        '/pages/contact': () => 'contact',
        '/pages/data-sharing-opt-out': () => 'privacy-choices',
        '/collections': () => 'collections',
        '/collections/all': () => 'products',
        '/collections/:handle': tokens => ({ name: 'collection', handle: tokens.handle }),
        '/products/:handle': tokens => ({ name: 'product', handle: tokens.handle })
      }, { url: normalizePath(attrs.pathname || window.location.pathname) });
      const destination = route ? route.controller(route.tokens) : 'not-found';

      if (destination === 'home') return m(Home, attrs);
      if (destination === 'products') return m(ProductsPage, attrs);
      if (destination === 'about') return m(AboutPage);
      if (destination === 'cart') return m(CartPage, attrs);
      if (destination === 'contact') return m(ContactPage);
      if (destination === 'privacy-policy') return m(PrivacyPolicyPage);
      if (destination === 'privacy-choices') return m(PrivacyChoicesPage);
      if (destination === 'collections') return m(CollectionsPage, attrs);
      if (destination?.name === 'collection') return m(CollectionPage, { ...attrs, handle: destination.handle });
      if (destination === 'not-found') return m(NotFoundPage);

      return m(ProductPage, { ...attrs, product: attrs.selectedProduct, handle: destination.handle });
    }
  };
}

function normalizePath(pathname) {
  return pathname.replace(/\/$/, '') || '/';
}

module.exports = { Pages };
